import './App.css';
import ClientFeedbackCards from "./ClientFeedbackCards";

function App () {
	return (
		<>
			<ClientFeedbackCards/>
		</>
	);
}

export default App;
